export default __webpack_public_path__ + "static/media/ratingsBG.9964f32e.svg";